import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language : "en",
    userProfile : null,
    doctorReferece : false,
    selectedStateID : null,
    allApptType : [],
    form : {},
    currentStep : 1,
    selectedMonth : null,
    selectedDate : null,
    avaiableDates : [],
    avaiableTimes : [],
    selectedGC : null,
    selectedTime : null,
    uploadId : null,
    coupon : null,
    inOffice : false,
  },
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
  },
  mutations: {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField,
  },
  actions: {
  },
  modules: {
  }
})
